import { helpers } from './base'

const white = 'brand.white'
const darkCityGreen = 'brand.darkCityGreen'

export const StickyBanner = helpers.defineMultiStyleConfig({
  baseStyle: {
    wrapper: { backgroundColor: 'brand.teal5' },
    banner: {},
    icon: { color: 'brand.primaryTeal' },
    message: {
      color: 'brand.black',
    },
    crossIcon: {},
  },
  variants: {
    ERROR: {
      message: {
        color: white,
      },
      icon: { color: white },
      wrapper: {
        backgroundColor: 'brand.red',
        color: white,
      },
      crossIcon: {
        ':focus-visible': {
          outlineColor: white,
        },
      },
    },
    INFO: {
      icon: { color: darkCityGreen },
      wrapper: {
        color: darkCityGreen,
      },
    },
    SUCCESS: {
      icon: { color: darkCityGreen },
      wrapper: {
        color: darkCityGreen,
      },
    },
    WARNING: {
      icon: { color: 'brand.red' },
      wrapper: {
        backgroundColor: 'brand.red5',
        color: 'brand.red',
      },
    },
    PROMOTION: {
      message: {
        color: 'brand.primaryTeal',
      },
    },
  },
})
